export default __webpack_public_path__ + "0c186f788dc76b0e7ed77882c7ba26a8.svg";